// @flow

import { hpfetch } from '../util';
import type { reviewType } from '../../types';
import type {
  djangoModelApiResponse,
  wrappedApiResponseType,
} from '../apiTypes';

export const getSingle = (
  id: number,
): Promise<wrappedApiResponseType<reviewType>> => hpfetch(`reviews/${id}/`);

export const getMany = (
  limit: number = 100,
  offset: number = 0,
): djangoModelApiResponse<reviewType> =>
  hpfetch(`reviews/?limit=${limit}&offset=${offset}`);

export const create = (transaction: number, review: string, stars: number) =>
  hpfetch('reviews/', {
    method: 'POST',
    body: JSON.stringify({
      transaction,
      stars,
      review,
    }),
  });

export const update = (reviewId: number, review: string, stars: number) =>
  hpfetch(`reviews/${reviewId}/`, {
    method: 'PATCH',
    body: JSON.stringify({
      review,
      stars,
    }),
  });

export const updateWithResponse = (reviewId: number, response: string) =>
  hpfetch(`reviews/${reviewId}/`, {
    method: 'PATCH',
    body: JSON.stringify({
      response,
    }),
  });
